export default __webpack_public_path__ + "static/media/arrow-next-carousel.dc2d6232.svg";